import { QosErrorMessage } from '@bimdata/definitions/dto';
import api from './api';

async function register(body: QosErrorMessage): Promise<void> {
  if (!api.getSession()) return;
  await api.post(`/qos/register`, body);
}

export { register };